import React, { useEffect, useState } from 'react';
import moment from 'moment';

import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

import pLimit from 'p-limit';
import { v4 as uuidv4 } from 'uuid';
import { addTotalForDownload, downloadFile, transNumber } from './utils';
import columnsMap from './utils/columns-map';
import { sortable } from 'tea-component/lib/table/addons';

import Downloading from '@/pages/opinion/assets/imgs/downloading.png';
import XlsxIcon from '@/pages/opinion/assets/svg/xlsx-icon.svg';

import {
  downloadKeyMetrics,
  getOpinionFeedsCommentsInfoDownload,
  getOpinionFeedsSearchDownload,
  getTrendsTotalHeatDownload,
  getTrendsDAUDownload,
  getTrendsListDownload,
  getFeedsComments,
  getFeedsSearchComments,
  getInfluencerCreatorList,
  getStreamingChannelShare,
  getFeedsKeyword,
  getStreamingDownloadTrends,
  getHeroTableDate,
  getHashtagTableDate,
  getFollowersDataInfo,
  getPublishingTimelineDataInfo,
  getMetricsTableForDownloadTableList,
  getTopicTimeline,
  getWordDownload,
  getCommunityVideoBatchTimeLine,
  downloadSteamMetrics,
  getKolBrandProfile,
  getKolBrandPerformance,
  getOverviewPcConsoleTimeline,
  getOverviewLanguage,
  getOverviewKeyword,
  getInfluencerCreatorTimeline,
  getInfluencerGenreLanguageStats,
  getInfluencerGenreCreatorList,
  getOverviewCompetitorTimeline,
  getOverviewCompetitorTable,
  getFeedsReplyComments,
} from '@op/services';

import './index.scss';

import { EXCEL_TYPE } from '@op/constants';
import { Icon } from 'tea-component';

import { urlToMap } from '@op/utils/url';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import CacheExpiredTips from '@op/components/CacheExpiredTips';
import {
  arrayToSimpleObj,
  dealwithNewOldData,
  getRationPercentValue,
  sortMapAuxiliaryFunc,
  sortTimeListFunc,
  supplementSingleData,
  uniqueArray,
} from '@/pages/opinion/utils';
import { dealwithTableData } from '@/pages/opinion/pages/Hero/utils';
import { copyAndDuplicateKeyword } from '@/pages/opinion/utils/keyword';
import { formatNewData } from '@/pages/opinion/utils/data';
import {
  dealwithGrowthChartRatio,
  dealwithTableCommentData,
} from '@/pages/opinion/pages/accounts/utils';
import { showTargetItems } from '@/pages/opinion/pages/accounts/constants';
import { dealwithTimeLineData } from '@/pages/opinion/pages/Summary/utils';
import { getAigcSummary } from '../../Aigc/utils';
import { useIntl } from 'umi';
import { getBasePath } from '@/utils/utils';
import { getServerGameInfo } from '@/pages/opinion/utils/game';
import { dealwithPcConsoleTimeline } from '@op/pages/gamestore/utils';
import {
  dealwithFilteredReviewsNewOldTableData,
  dealwithFilteredReviewsTableData,
  dealwithLanguageTableData,
  dealwithNewOldTimelineToTable,
  downloadAddedReviewsDealwith,
} from '@op/pages/SteamPerformance/utils';
import { dealwithInfluenceTableData } from '@op/pages/Influencer/utils';
import { genreCreatorListDataKeys } from '@op/pages/Influencer/constants';
import { donwloadVideoDealwith } from '@op/pages/community/video/components/utils';
import {
  getAllLogValue,
  getLogValue,
} from '@op/pages/feeds/hooks/useFeedsRequest';
import {
  dealWithMentionsSentimentChart,
  dealwithMentionsSentimentTable,
  dealWithMobileGameStoreTable,
  dealWithSteamTable,
} from '@op/pages/Overview/CompareKeyMetrics/utils';
import { getGameDataIndex } from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import { getVideoSummary } from '@op/pages/community/video/hooks';
import { getVoiceReportingTextAnalysisDetails } from '@op/services/voiceReportingTextAnalysis';
import {
  clearDownloadStorage,
  downloadParamsPrefix,
  safeSetItem,
} from '@op/utils/storageUtils';
const LIST_LIMIT = 1000;
async function getGameName(gameId: string) {
  const sessionGameInfo = JSON.parse(
    localStorage.getItem('OpinionGameInfo') || '{}',
  );
  if (gameId === sessionGameInfo.edition_unified_id) {
    const gameName = sessionGameInfo?.entity_name || '';
    return gameName;
  }

  const game = await getServerGameInfo(gameId);

  return game?.entity_name;
}

export async function downloadAction({
  fileName: paramsFileName,
  downLoadParams,
  downloadFunc = 'downloadKeyMetrics',
  limit = Infinity,
  total = -Infinity,
  sheetName = 'Sheet',
  simpleName,
  align = 'auto',
}: {
  fileName?: string;
  downLoadParams: any;
  downloadFunc: string;
  limit?: number;
  total?: number;
  sheetName?:
  | string
  | {
    name: string;
    addOn: any;
    replaceName: string;
  }[];
  simpleName?: string;
  align?: string;
}) {
  let fileName = paramsFileName;

  if (simpleName) {
    const gameName = await getGameName(downLoadParams.edition_unified_id);
    // 这个名称有点问题，需要后期调整
    fileName = `Opinions_${gameName}_${simpleName}_${moment(
      downLoadParams.start_time,
    ).format('YYYYMMDD')}_${moment(downLoadParams.end_time).format(
      'YYYYMMDD',
    )}`;
  }

  fileName = fileName?.replace(/[\\/:*?."<>|]/g, '');

  const storageParams = {
    fileName,
    params: downLoadParams,
    downloadFunc,
    limit,
    total,
    sheetName,
    align,
    downloadTime: new Date().getTime(),
  };

  const downloadId = uuidv4();

  // 写入失败时safeSetItem内部会逐级清理并提示，此时无需打开下载页
  const setResult = safeSetItem(
    localStorage,
    `${downloadParamsPrefix}-${downloadId}`,
    JSON.stringify(storageParams),
    downloadParamsPrefix,
  );

  if (!setResult) return;

  (window as any).aegis?.infoAll?.(
    JSON.stringify({
      action: 'download',
      downloadId,
      storageParams,
    }),
  );

  window.open(`${getBasePath()}/opinion/download?id=${downloadId}`, '_blank');
}

export default function DownloadPage() {
  // 参考 https://databrain.intlgame.com/intelligence_detail/download.html?entityType=mobile&taskId=2825498722

  const { formatMessage } = useIntl();
  const { readParams } = useDownloadParams();
  /** 参数读取失败（缓存失效）时展示兜底提示 */
  const [invalid, setInvalid] = useState(false);

  const [desc, setDesc] = useState(
    <>
      {formatMessage({
        id: 'Please do not close the tabs during the download process.',
      })}
    </>,
  );

  const [percent, setPercent] = useState(0);

  const map = urlToMap(window.location.href);

  let intervalID: ReturnType<typeof setInterval>;
  const mockPercent = (
    from: number,
    to: number,
    mockIntervalTime = 100,
    step?: number,
  ) => {
    clearInterval(intervalID);
    let num = from;
    intervalID = setInterval(() => {
      // console.log('set mock', Math.random());
      num += step ?? Math.floor(Math.random() * ((to - from) / 2));
      if (num >= to) num = Math.max(0, to - 1);
      setPercent(Math.max(from, Math.floor(num)));
    }, mockIntervalTime);
  };

  const [sheetNames, setSheetNames] = useState('Sheet');

  const [curFileName, setCurFileName] = useState('filename');
  const [maxErrorVisible, setMaxErrorVisible] = useState(false);

  const [limit, setLimit] = useState(Infinity);
  const [errorType, setErrorType] = useState('');
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>(
    'loading',
  );

  const downloadFuncs: any = {
    downloadKeyMetrics,
    getOpinionFeedsCommentsInfoDownload,
    getOpinionFeedsSearchDownload,
    getStreamingDownloadTrends,
    getTrendsTotalHeatDownload,
    getTrendsDAUDownload,
    getTrendsListDownload,
    getHeroTableDate,
  };

  const downloadWithLists: any = {
    getOpinionFeedsCommentsInfoDownload: {
      func: getFeedsComments,
      dataKey: {
        'Game Store': 'list',
        'Social Media': 'list', // 和 feedback 共用
        'Private Source': 'list', // 和 feedback 共用
        Chatting: 'list', // 和 feedback 共用
        'Security Channel': 'list', // 和 feedback 共用
        'News Media': 'news_detail_info',
        'Private Discord': 'list',
        'Player Feedback': 'list',
      },
    },
    getOpinionFeedsSearchDownload: {
      func: getFeedsSearchComments,
      dataKey: {
        'Game Store': 'list',
        'Social Media': 'list', // 和 feedback 共用
        'Private Source': 'list', // 和 feedback 共用
        'News Media': 'news_detail_info',
        Chatting: 'list', // 和 feedback 共用
        'Security Channel': 'list', // 和 feedback 共用
        'Private Discord': 'list',
        'Player Feedback': 'list',
      },
    },
    getHeroTableDate: {
      func: getHeroTableDate,
      dataKey: {
        Hero: 'new_list',
      },
    },
    getHashtagTableDate: {
      func: getHashtagTableDate,
      dataKey: {
        Hashtag: 'new_list',
      },
    },
    getReplayDownload: {
      func: getFeedsComments,
      dataKey: {
        'Game Store Feeds': 'list',
        'Social Media Feeds': 'list', // 和 feedback 共用
        'News Media Feed': 'news_detail_info',
      },
    },
    getStreamingChannelShare: {
      func: getStreamingChannelShare,
      dataKey: {
        Streamer: 'list',
      },
    },
    getInfluencerCreatorList: {
      func: getInfluencerCreatorList,
      dataKey: {
        Influencer: 'list',
      },
    },
    getOpinionVideoComments: {
      func: getFeedsComments,
      dataKey: {
        Video: 'list',
        TrendingVideo: 'list',
      },
    },
    getPublishingTimelineDataInfo: {
      func: getPublishingTimelineDataInfo,
      dataKey: {
        Engagements: 'list',
      },
    },
    getFollowersDataInfo: {
      func: getFollowersDataInfo,
      dataKey: {
        Followers: 'list',
        'Growth of Followers': 'list',
        'Audience Performance': 'list',
      },
    },
    getInfluencerCreatorTimeline: {
      func: getInfluencerCreatorTimeline,
      dataKey: {
        'Compare By Influencer': 'timeline',
      },
    },
    getCommunityVideoBatchTimeLine: {
      func: getCommunityVideoBatchTimeLine,
      dataKey: {
        'Video Chart': 'list',
      },
    },
    getMetricsTableForDownloadTableList: {
      func: getMetricsTableForDownloadTableList,
      dataKey: {
        'Account Metrics Table': 'new_list',
      },
    },
    getTopicTimeline: {
      func: getTopicTimeline,
      dataKey: {
        TopicTrends: 'list',
      },
    },
    downloadKeyMetrics: {
      func: downloadKeyMetrics,
      dataKey: {
        'Key Metrics': 'list',
      },
    },
    downloadSteamMetrics: {
      func: downloadSteamMetrics,
      dataKey: {
        'Steam Performance': 'data',
      },
    },
    getWordDownload: {
      func: getWordDownload,
      dataKey: {
        'Anchor Words': 'list',
      },
    },
    getKolBrandProfile: {
      func: getKolBrandProfile,
      dataKey: {
        'Influencer Counts': 'timeline',
        'Channel Distribution': 'channel',
      },
    },
    getKolBrandPerformance: {
      func: getKolBrandPerformance,
      dataKey: {
        'Publication Counts': 'metrics',
        'Performance Analysis': 'metrics',
      },
    },
    getOverviewPcConsoleTimeline: {
      func: getOverviewPcConsoleTimeline,
      dataKey: {
        'Steam All Reviews': 'list',
        'Steam Recent Reviews': 'list',
        'Added Reviews': 'list',
        'Realtime Steam All Reviews': 'list',
        'Realtime Steam Recent Reviews': 'list',
        'Realtime Added Reviews': 'list',
        'Realtime Added Stacked Reviews': 'list',
        'Steam Realtime Newly Added': 'list',
      },
    },
    getOverviewLanguage: {
      func: getOverviewLanguage,
      dataKey: {
        'Steam Reviews Detailed Language': 'timeline_of_mentions',
      },
    },
    getFeedsKeyword: {
      func: getFeedsKeyword,
      dataKey: {
        'Steam Reviews Detailed Keyword': 'timeline_mentions',
      },
    },
    getOverviewKeyword: {
      func: getOverviewKeyword,
      dataKey: {
        'Overview Keyword Timeline': 'timeline_mentions',
      },
    },
    getInfluencerGenreLanguageStats: {
      func: getInfluencerGenreLanguageStats,
      dataKey: {
        'Filtered Creator Language Distribution': 'list',
      },
    },
    getInfluencerGenreCreatorList: {
      func: getInfluencerGenreCreatorList,
      dataKey: {
        'Genre Creator List': 'list',
      },
    },
    getCompareKeyMetrics: {
      func: getOverviewCompetitorTimeline,
      dataKey: {
        'Compare Key Metrics': 'list',
      },
    },
    getOverviewCompetitorTable: {
      func: getOverviewCompetitorTable,
      dataKey: {
        'Compare Key Metrics Mentions & Sentiment Table': 'list',
        'Compare Key Metrics Game Store Table': 'list',
        'Compare Key Metrics Community Table': 'list',
        'Compare Key Metrics PR Table': 'list',
        'Compare Key Metrics Steam Table': 'list',
      },
    },
    getKeyMetrics: {
      func: getOverviewCompetitorTimeline,
      dataKey: {
        'Key Metrics Google Trends': 'list',
      },
    },
    getFeedsDetails: {
      func: getFeedsReplyComments,
      dataKey: {
        'Post Reviews': 'list',
      },
    },
    getVoiceReportingTextAnalysisDetails: {
      func: getVoiceReportingTextAnalysisDetails,
      dataKey: {
        'Voice Reporting Text Analysis Details': 'detail_list',
      },
    },
  };

  useEffect(() => {
    download();

    window.addEventListener('unload', function () {
      clearDownloadStorage();
    });

    return () => {
      clearInterval(intervalID);
    };
  }, []);

  const download = async () => {
    const serverId = map.get('id');

    // 方案 1：从服务端/本地存储读取（由 Hook 内部处理）
    let downLoadParams = await readParams();

    // 方案 2：原有 localStorage 逻辑（兼容无 _s 标记的旧 URL）
    if (!downLoadParams) {
      downLoadParams = localStorage.getItem('downLoadParams');

      if (serverId) {
        downLoadParams = localStorage.getItem(`downLoadParams-${serverId}`);
      }
    }

    (window as any).aegis?.infoAll?.(
      JSON.stringify({
        action: 'downloadPageInit',
        downloadId: serverId,
        storageParams: downLoadParams,
      }),
    );

    if (downLoadParams) {
      try {
        // 兼容两种来源：
        // - 方案 1（readParams）：已解析为对象（新/旧结构 data）
        // - 方案 2（localStorage 字符串）：需 JSON.parse
        const curDownLoadParams =
          typeof downLoadParams === 'string'
            ? JSON.parse(downLoadParams)
            : downLoadParams;
        const {
          downloadFunc = 'downloadKeyMetrics',
          limit: curLimit = Infinity,
          total: curTotal = -Infinity,
          sheetName: sheetNames = 'Sheet',
          align = 'auto',
          fileName,
        } = curDownLoadParams;

        setSheetNames(sheetNames);

        let newFileName = '';

        setCurFileName(fileName);
        curLimit && setLimit(curLimit);

        if (sheetNames === 'AIGC') {
          // console.log('特殊处理AIGC');
          mockPercent(0, 99, 1000, 1);
          setDesc(
            <>
              {formatMessage({
                id: 'This process will take 1 to 3 minutes, depending on the submitted content.',
              })}
              <br />
              {formatMessage({ id: 'Please do not close this page - download.' })}
            </>,
          );
          const { prompt, ...aigcParams } = curDownLoadParams.params;
          const getAigcSummaryRes = await getAigcSummary({
            params: aigcParams,
            prompt,
          });
          if (getAigcSummaryRes.status === 'success') {
            setStatus('success');
            setPercent(100);
            clearInterval(intervalID);
            const blob = new Blob([getAigcSummaryRes.data], {
              type: 'text/plain',
            });
            FileSaver.saveAs(blob, fileName);
          } else {
            setStatus('error');
            setPercent(100);
            clearInterval(intervalID);
          }
          // 调用分析
        } else {
          if (curLimit < curTotal) {
            setStatus('error');
            setPercent(100);
            setMaxErrorVisible(true);
          } else {
            if (downloadWithLists[downloadFunc]) {
              const { func } = downloadWithLists[downloadFunc];

              const dealSheet = async (
                sheetName: string | undefined,
                moreParams?: object | undefined,
                replaceName?: undefined,
              ) => {
                let { params } = curDownLoadParams;

                if (moreParams) {
                  params = Object.assign({
                    ...params,
                    ...moreParams,
                  });

                  newFileName = fileName.replace(replaceName, sheetName);
                }

                console.log('newFileName', newFileName);

                console.log(sheetName);
                let { columns } = columnsMap[sheetName] || {};

                columns =
                  typeof columns === 'function' ? columns(params) : columns;
                const dataKey =
                  downloadWithLists[downloadFunc].dataKey?.[sheetName] ||
                  'list';
                console.log(columns);
                if (
                  downloadFunc === 'getOpinionFeedsCommentsInfoDownload' &&
                  sheetName === 'Game Store'
                ) {
                  const { channel } = params;
                  const hasSteam =
                    Array.isArray(channel) &&
                    (channel.length === 0 || channel.includes('steam'));
                  if (!hasSteam) {
                    console.log('特殊处理没有 steam 的 columns');
                    columns = columns.filter(
                      (item) => !(['On Record Time(hours)', 'At Review Time(hours)']?.includes(item.header)),
                    );
                  }
                }

                if (
                  downloadFunc === 'getOpinionFeedsCommentsInfoDownload' &&
                  sheetName === 'Social Media'
                ) {
                  const { channelList } = params || {};
                  if (!channelList?.includes('chzzk')) {
                    columns = columns.filter(item => !(item.header === 'Live Broadcast Views'));
                  }
                }

                if (downloadFunc === 'getInfluencerCreatorList' || downloadFunc === 'getInfluencerGenreCreatorList') {
                  const { extraParams, ...restParams } = params;
                  params = restParams;
                }

                // default: page: 1, page_size: 10000
                // 需要分页下载
                params.page = 1;
                params.page_size = params.noChangePageSize
                  ? params.page_size > 1000
                    ? 1000
                    : params.page_size
                  : LIST_LIMIT;

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet(sheetName);

                type columnsType = {
                  header: string;
                  key?: string;
                  width?: number;
                  children?: any[];
                  render?: ((item: any) => string) | string;
                  worksheetColumns?: string;
                  renderHelper?: Function[];
                  numFmt?: string;
                };

                const worksheetColumns: columnsType[] = [];

                const row1: string[] = [];
                const row2: string[] = [];
                let hasChild = false;
                for (let index = 0; index < columns.length; index += 1) {
                  const {
                    children = [],
                    header: headerTextOrFun,
                    key,
                    width,
                    render,
                    numFmt,
                    renderHelper = [],
                  } = columns[index];
                  const header =
                    typeof headerTextOrFun === 'function'
                      ? headerTextOrFun(params)
                      : headerTextOrFun;
                  const pushItem = {
                    header,
                    key: key ?? header,
                    width: width ?? 20,
                    render,
                    numFmt,
                    children,
                    renderHelper,
                  };
                  if (
                    !children ||
                    !Array.isArray(children) ||
                    children.length === 0
                  ) {
                    row1.push(header);
                    row2.push('');
                    worksheetColumns.push(pushItem);
                  } else {
                    row2.push(
                      ...children.map((item) => {
                        row1.push(header);
                        return item.header;
                      }),
                    );
                    for (
                      let innerIndex = 0;
                      innerIndex < children.length;
                      innerIndex += 1
                    ) {
                      const headerTextOrFun = children[innerIndex].header;
                      const childHeader =
                        typeof headerTextOrFun === 'function'
                          ? headerTextOrFun(params)
                          : headerTextOrFun;

                      children[innerIndex].header = childHeader;

                      worksheetColumns.push({
                        ...pushItem,
                        header,
                        key: header || children[innerIndex].key || pushItem.key,
                        render: children[innerIndex].render || pushItem.render,
                        numFmt: children[innerIndex].numFmt || pushItem.numFmt,
                        renderHelper:
                          children[innerIndex].renderHelper ||
                          pushItem.renderHelper,
                        width: children[innerIndex].width || pushItem.width,
                      });
                    }
                    hasChild = true;
                  }
                }

                worksheet.addRow(row1);
                if (hasChild) {
                  worksheet.addRow(row2);
                }

                console.log(worksheetColumns);

                for (let index = 0; index < worksheetColumns.length;) {
                  const { children } = worksheetColumns[index];

                  const cell = worksheet.getCell(1, index + 1);
                  cell.alignment = { vertical: 'middle' };

                  if (
                    !children ||
                    !Array.isArray(children) ||
                    children.length === 0
                  ) {
                    worksheet.mergeCells(
                      1,
                      index + 1,
                      hasChild ? 2 : 1,
                      index + 1,
                    );
                    index += 1;
                  } else {
                    worksheet.mergeCells(
                      1,
                      index + 1,
                      1,
                      index + children.length,
                    );

                    cell.alignment = {
                      vertical: 'middle',
                      horizontal: 'center',
                    };

                    index += children.length;
                  }
                }
                do {
                  let perPercent;
                  if (curTotal < params.page_size) {
                    perPercent = 100;
                  } else {
                    perPercent = 100 / Math.ceil(curTotal / params.page_size);
                  }

                  const percentMin = Math.max(
                    0,
                    Math.floor((params.page - 1) * perPercent),
                  );
                  const percentMax = Math.min(
                    Math.floor(params.page * perPercent),
                    99,
                  ); // hero 需要特殊处理，让停在 99
                  mockPercent(percentMin, percentMax);
                  let res: any = {};
                  try {
                    res = await func({ ...params }, true);
                  } catch (error) {
                    setStatus('error');
                    throw error;
                  }

                  if (sheetName === 'Post Reviews') {
                    const data = res?.[dataKey] || [];
                    const sentimentMap = await getAllLogValue(
                      data,
                      {},
                      { value_type: ['sentiment', 'valid'] },
                    );
                    data.map(
                      (item: {
                        sentiment_rating: any;
                        topic: string;
                        isvalid: string;
                      }) => {
                        const [newSentiment, newValid] = [
                          'latest_sentiment',
                          'latest_valid',
                        ].map((key) =>
                          getLogValue(sentimentMap, item, key as any),
                        );

                        const sentimentDefaultValue = params.hideSentimentRating
                          ? null
                          : item.sentiment_rating;
                        item.sentiment_rating =
                          newSentiment || sentimentDefaultValue;
                        item.isvalid = newValid || item.isvalid;
                      },
                    );
                  }

                  if (
                    [
                      'Game Store',
                      'Social Media',
                      'Private Source',
                      'Chatting',
                      'Security Channel',
                      'Private Discord',
                      'Player Feedback',
                      'Game Store Feeds',
                      'Social Media Feeds',
                    ].includes(sheetName)
                  ) {
                    const data = res?.[dataKey] || [];
                    const sentimentMap = await getAllLogValue(
                      data,
                      {},
                      { value_type: ['sentiment', 'topic', 'valid'] },
                    );
                    data.map(
                      (item: {
                        sentiment_rating: any;
                        topic: string;
                        isvalid: string;
                      }) => {
                        const [newSentiment, newTopic, newValid] = [
                          'latest_sentiment',
                          'latest_topic',
                          'latest_valid',
                        ].map((key) =>
                          getLogValue(sentimentMap, item, key as any),
                        );

                        const sentimentDefaultValue = params.hideSentimentRating
                          ? null
                          : item.sentiment_rating;
                        item.sentiment_rating =
                          newSentiment || sentimentDefaultValue;

                        item.isvalid = newValid || item.isvalid;
                        item.topic = newTopic || item.topic;
                      },
                    );
                  }
                  // video 下载已经转到新的下载了
                  // if (sheetName === 'Video') {
                  //   const gptSummary = await getVideoSummary(res);
                  //   const data = res?.[dataKey] || [];

                  //   data.forEach((item: any) => {
                  //     const key = item.comment_uin;
                  //     const { summary_cn, summary_en, summary_sentiment } =
                  //       gptSummary?.[key] || {};

                  //     item.summary_en = summary_en;
                  //     item.summary_cn = summary_cn;
                  //     item.summary_sentiment = summary_sentiment;
                  //   });
                  // }

                  clearInterval(intervalID);
                  setPercent(Math.floor(percentMax));
                  const dateType = params.date_type;
                  // if (!(res?.data?.[dataKey]?.length > 0 && Array.isArray(res.data[dataKey]))) {
                  //   setStatus('error');
                  //   setPercent(100);
                  //   clearInterval(intervalID);
                  //   return;
                  // }

                  // todo 这一块的特殊数据处理可以提取出去，在对应页面进行方法的声明，这里只负责引用
                  let list = res?.[dataKey] || [];

                  if (sheetName === 'Hero' || sheetName === 'Hashtag') {
                    // 特殊处理
                    list = dealwithTableData(
                      res[dataKey],
                      res.old_list,
                      res.max,
                    );
                    console.log(`${sheetName} list`, list);
                  }

                  if (sheetName === 'Streamer') {
                    list = list
                      ?.map((item) => ({
                        ...item,
                        ration_percent: getRationPercentValue(
                          item.new,
                          item.old,
                        ),
                        value: item.new,
                      }))
                      ?.sort(
                        sortable.comparer([
                          { by: params.sort_item, order: params.sort_model },
                        ]),
                      );
                  }

                  if (sheetName === 'Influencer') {
                    // 特殊处理
                    const {
                      list: new_list,
                      old_list,
                      max_item,
                      user_infos,
                      old_plus_list,
                    } = res || {};
                    const mediaType = params.media_types.includes('stream')
                      ? 'stream'
                      : 'others';
                    const resultList = (new_list || []).map(
                      (item: { [x: string]: any }) => {
                        const otherInfo = [
                          'engagements',
                          'posts',
                          'views',
                          'likes',
                          'comments',
                        ].reduce((pre, cur) => {
                          if (mediaType === 'stream') return {};
                          const info = arrayToSimpleObj(
                            item[cur] || [],
                            'value',
                            'name',
                          );
                          return {
                            ...pre,
                            ...info,
                          };
                        }, {});
                        return {
                          ...item,
                          ...otherInfo,
                        };
                      },
                    );
                    list =
                      dealwithInfluenceTableData({
                        new_list: resultList,
                        old_list,
                        old_plus_list,
                        user_info_list: user_infos,
                        max_item,
                        media_type: mediaType,
                      }) || [];

                    list = list.sort(
                      sortable.comparer([
                        { by: params.sort_item, order: params.sort_model },
                      ]),
                    );
                  }

                  if (sheetName === 'Genre Creator List') {
                    // 特殊处理
                    const {
                      list: new_list,
                      old_list,
                      max_item,
                      old_plus_list,
                    } = res || {};
                    list =
                      dealwithInfluenceTableData({
                        new_list,
                        old_list,
                        old_plus_list,
                        max_item,
                        key: 'author_md5',
                        valueKeys: genreCreatorListDataKeys,
                      }) || [];

                    list = list.sort(
                      sortable.comparer([
                        { by: params.sort_item, order: params.sort_model },
                      ]),
                    );
                  }

                  if (sheetName === 'TopicTrends') {
                    const { date_type, indicators, start_time, end_time } =
                      params || 'daily';
                    const { tableInfo } = dealwithTimeLineData(
                      res || {},
                      undefined,
                      date_type,
                      indicators,
                      true,
                      false,
                      start_time,
                      end_time,
                    );
                    list = tableInfo.data;
                  }

                  if (
                    [
                      'Audience Performance',
                      'Followers',
                      'Publishing Performance',
                    ].includes(sheetName)
                  ) {
                    const type = params.metrics[0];
                    let {
                      list: newList,
                      timeline_of_start_time,
                      timeline_of_end_time,
                      sorts,
                    } = res || {};
                    newList = formatNewData(
                      (newList?.[type]?.timeline || []) as any,
                    );
                    newList = supplementSingleData(
                      timeline_of_start_time,
                      timeline_of_end_time,
                      newList,
                      dateType,
                      sorts,
                    );
                    list = dealwithTableCommentData(newList, dateType);
                  }

                  if (sheetName === 'Video Chart') {
                    // let { list: newList } = res || {};
                    // newList = formatNewData(newList || []);
                    // list = dealwithTableCommentData(newList, dateType);
                    // list.sort(sortTimeListFunc('time'));
                    list = donwloadVideoDealwith(res, params);
                  }

                  if (['Compare By Influencer'].includes(sheetName)) {
                    list.sort(sortTimeListFunc('time'));
                  }

                  if (
                    ['Publication Counts', 'Performance Analysis'].includes(
                      sheetName,
                    )
                  ) {
                    const { INNER_METRIC_TYPE, media_types } = params;
                    const { timeline } = list?.[INNER_METRIC_TYPE] || {};
                    list = timeline || [];

                    if (media_types?.[0] === 'stream') {
                      list.sort(sortTimeListFunc('time', 'desc'));
                    } else {
                      list = addTotalForDownload(list);
                    }
                  }
                  if (sheetName === 'Influencer Counts') {
                    list = addTotalForDownload(list);
                  }

                  if (sheetName === 'Growth of Followers') {
                    const type = params.metrics[0];
                    // 后期需要对handleMentionData方法进行重写
                    const {
                      list: newList,
                      timeline_of_start_time,
                      timeline_of_end_time,
                      sorts,
                    } = res || {};
                    list = formatNewData(
                      (newList?.[type]?.timeline || []) as any,
                    );
                    const local_start_time = moment(timeline_of_start_time)
                      .subtract(1, 'days')
                      .format('YYYY-MM-DD');
                    const localList = supplementSingleData(
                      local_start_time,
                      timeline_of_end_time,
                      list,
                      dateType,
                      sorts,
                    );
                    // 处理增长量数据
                    const { table } = dealwithGrowthChartRatio(
                      timeline_of_start_time,
                      timeline_of_end_time,
                      localList,
                      dateType,
                    );
                    list = table;
                  }

                  if (sheetName === 'Account Metrics Table') {
                    const { new_list, old_list } = res || {};
                    const dataList = dealwithNewOldData(
                      new_list,
                      old_list,
                      'name',
                      showTargetItems,
                    );
                    list = dataList;
                  }

                  if (sheetName === 'Anchor Words') {
                    let {
                      list = [],
                      old_list = [],
                      link_of_start_time,
                      link_of_end_time,
                    } = res || {};

                    const oldTime = [link_of_start_time, link_of_end_time];
                    const newTime = [params.start_time, params.end_time];

                    const formateDate = (value) => {
                      if (params.date_type == 'hourly') {
                        return moment(value).format('YYYY-MM-DD HH:mm');
                      }
                      return moment(value).format('YYYY-MM-DD');
                    };
                    const oldTimeText = uniqueArray(
                      oldTime?.map(formateDate),
                    )?.join(' - ');
                    const newTimeText = uniqueArray(
                      newTime?.map(formateDate),
                    )?.join(' - ');

                    const newList: any[] = [];

                    const oldListMap = {};
                    for (let index = 0; index < old_list?.length; index += 1) {
                      const curItem = old_list[index];
                      if (!oldListMap[curItem.head]) {
                        oldListMap[curItem.head] = {
                          ...curItem,
                          rank: index + 1,
                        };
                      }
                    }

                    for (let index = 0; index < list.length; index += 1) {
                      const curItem = list[index];

                      curItem.rank = index + 1;
                      curItem.rank_change = '-';
                      curItem.old_rank = '-';

                      if (oldListMap[curItem.head]) {
                        const oldItem = oldListMap[curItem.head];
                        curItem.old_rank = oldItem.rank;
                        const rank_change = oldItem.rank - curItem.rank;
                        curItem.rank_change = rank_change;
                      }

                      newList.push(curItem);
                    }

                    worksheetColumns[3].header = `Rank（${newTimeText}）`;
                    worksheetColumns[4].header = `Rank（${oldTimeText}）`;

                    console.log('Anchor Words', newList, worksheet.columns);

                    list = newList;
                  }

                  if (
                    [
                      'Steam Reviews Detailed Keyword',
                      'Steam Performance',
                    ].includes(sheetName)
                  ) {
                    list = res || [];
                  }

                  if (
                    [
                      'Steam All Reviews',
                      'Steam Recent Reviews',
                      'Added Reviews',
                    ].includes(sheetName)
                  ) {
                    const { valueKey } = params;
                    const globalResult = dealwithPcConsoleTimeline(list);
                    if (['Added Reviews'].includes(sheetName)) {
                      list = dealwithFilteredReviewsTableData(
                        globalResult?.steam?.list,
                      );
                    } else {
                      list = globalResult?.steam?.list?.[valueKey] || [];
                    }
                  }

                  if (sheetName === 'Steam Realtime Newly Added') {
                    const globalResult = dealwithPcConsoleTimeline(list);
                    list = dealwithFilteredReviewsNewOldTableData(
                      globalResult.steam,
                    );
                  }

                  if (
                    [
                      'Realtime Steam All Reviews',
                      'Realtime Steam Recent Reviews',
                    ].includes(sheetName)
                  ) {
                    const { valueKey } = params;
                    const globalResult = dealwithPcConsoleTimeline(list);
                    const { list: new_list, old_list } =
                      globalResult?.steam || {};
                    list = dealwithNewOldTimelineToTable(
                      new_list?.[valueKey] || [],
                      old_list?.[valueKey] || [],
                      ['review', 'score'],
                    );
                  }

                  if (
                    [
                      'Realtime Added Stacked Reviews',
                      'Realtime Added Reviews',
                    ].includes(sheetName)
                  ) {
                    list = downloadAddedReviewsDealwith(
                      list,
                      sheetName === 'Realtime Added Stacked Reviews',
                    );
                  }
                  if (sheetName === 'Steam Reviews Detailed Language') {
                    list = dealwithLanguageTableData(list);
                  }

                  if (
                    [
                      'Mentions & Sentiment',
                      'Game Store - Google Play',
                      'Game Store - App Store',
                      'Game Store - Steam',
                      'Community - Potential Impressions',
                      'Community - Publications',
                      'Community - Number of Creators',
                      'Community - Views',
                      'Community - Engagement',
                      'Community - Hours Watched',
                      'Community - Sessions',
                      'Community - Streamers',
                      'Community - Peak CCV',
                      'Community - Avg CCV',
                      'Community - Engagement Rate',
                      'Community - Followers',
                      'Google Trends',
                      'PR',
                    ].includes(sheetName)
                  ) {
                    const { tableData } = dealWithMentionsSentimentChart(
                      res,
                      params,
                    );
                    list = tableData;
                  }

                  if (
                    [
                      'Compare Key Metrics Mentions & Sentiment Table',
                      'Compare Key Metrics Game Store Table',
                      'Compare Key Metrics Community Table',
                      'Compare Key Metrics PR Table',
                      'Compare Key Metrics Steam Table',
                    ].includes(sheetName)
                  ) {
                    if (sheetName === 'Compare Key Metrics Steam Table') {
                      list = dealWithSteamTable(res, params);
                    } else if (
                      sheetName === 'Compare Key Metrics Game Store Table'
                    ) {
                      list = dealWithMobileGameStoreTable(res, params);
                    } else {
                      list = dealwithMentionsSentimentTable(res, params);
                    }
                    const sortMap = getGameDataIndex(params.gameData);
                    list.sort(
                      sortMapAuxiliaryFunc(
                        sortMap,
                        (item) => item.edition_unified_id,
                      ),
                    );
                  }

                  if (sheetName === 'Key Metrics Google Trends') {
                    const { tableData } = dealWithMentionsSentimentChart(
                      res,
                      params,
                    );
                    list = tableData;
                  }

                  worksheet.columns = worksheetColumns;

                  console.log(list);

                  const data = (list || []).map((item) => {
                    const renderData: string[] = [];
                    for (
                      let index = 0;
                      index < worksheetColumns.length;
                      index += 1
                    ) {
                      const worksheetColumn = worksheetColumns[index];
                      const { render, renderHelper = [] } = worksheetColumn;

                      if (!render && !renderHelper) return; // 特殊处理没有render的情况
                      if (render instanceof Function) {
                        renderData.push(render(item));
                      } else {
                        let renderItem = '';

                        if (render) {
                          renderItem = item[render];
                        }

                        if (
                          renderHelper &&
                          Array.isArray(renderHelper) &&
                          renderHelper.length > 0
                        ) {
                          for (
                            let innerIndex = 0;
                            innerIndex < renderHelper.length;
                            innerIndex += 1
                          ) {
                            renderItem = renderHelper[innerIndex](
                              item,
                              render,
                              params,
                            );
                          }
                        }

                        renderData.push(renderItem);
                      }
                    }
                    return renderData;
                  });

                  if (sheetName === 'Hero') {
                    const curPLimit = pLimit(5);
                    const {
                      page,
                      page_size,
                      sort_item,
                      sort_model,
                      ...keywordParams
                    } = params;
                    const input = list.map(({ name }) =>
                      curPLimit(() => {
                        const newParams = {
                          ...keywordParams,
                          keyword_top_n: 9,
                          keyword_sample_size: '50',
                          sentiment_type: '',
                          keyword_en: [name],
                          keyword_widely_match: true,
                        };
                        return getFeedsKeyword(newParams);
                      }),
                    );
                    const result = await Promise.all(input);
                    worksheet.addRows(
                      data.map((dataItem, index) => {
                        const newItem = dataItem.slice(0, -3);
                        let keywords = '';
                        let keywordCns = '';
                        let keywordEn = '';

                        console.log(result);

                        if (result?.[index]) {
                          const data = result[index];
                          if (Array.isArray(data) && data.length > 0) {
                            keywords = copyAndDuplicateKeyword(
                              data.map((item) => item.keyword),
                            ).join(',');
                            keywordCns = copyAndDuplicateKeyword(
                              data.map((item) => item.keyword_cn),
                            ).join(',');
                            keywordEn = copyAndDuplicateKeyword(
                              data.map((item) => item.keyword_en),
                            ).join(',');
                          }
                        }
                        return [...newItem, keywords, keywordCns, keywordEn];
                      }),
                    );
                  } else {
                    worksheet.addRows(data);
                  }

                  for (
                    let index = 0;
                    index < worksheetColumns.length;
                    index += 1
                  ) {
                    const { numFmt } = worksheetColumns[index];
                    worksheet.getColumn(index + 1).numFmt = numFmt;
                  }
                  for (let index = 0; index < data.length; index += 1) {
                    const supplement = hasChild ? 3 : 2;

                    const curIndex =
                      (params.page - 1) * params.page_size + index + supplement;
                    worksheet.getRow(curIndex).font = {
                      name: 'Verdana',
                      size: 12,
                    };
                    if (align === 'center') {
                      worksheet.getRow(curIndex).alignment = {
                        vertical: 'middle',
                        horizontal: 'center',
                      };
                    }
                    worksheet.getRow(curIndex).border = {
                      top: { style: 'dotted' },
                      left: { style: 'dotted' },
                      bottom: { style: 'dotted' },
                      right: { style: 'dotted' },
                    };
                  }
                  params.page += 1;
                } while (
                  params.page * params.page_size - params.page_size <
                  curTotal
                );
                const rowIndex = hasChild ? 2 : 1;
                for (let index = 0; index < rowIndex; index += 1) {
                  worksheet.getRow(index + 1).font = {
                    name: 'Verdana',
                    size: 12,
                    bold: true,
                  };
                  // worksheet.getRow(index + 1).alignment = { vertical: 'middle', horizontal: 'center' };
                  worksheet.getRow(index + 1).border = {
                    top: { style: 'dotted' },
                    left: { style: 'dotted' },
                    bottom: { style: 'dotted' },
                    right: { style: 'dotted' },
                  };
                }

                console.log('newFileName', JSON.stringify(newFileName));

                try {
                  const data = await workbook.xlsx.writeBuffer();
                  const blob = new Blob([data], { type: EXCEL_TYPE });
                  console.log(
                    'newFileName',
                    JSON.stringify(newFileName),
                    newFileName || fileName,
                  );
                  FileSaver.saveAs(blob, newFileName || fileName);
                  setStatus('success');
                  setPercent(100);
                  clearInterval(intervalID);
                } catch {
                  setStatus('error');
                  setPercent(100);
                  clearInterval(intervalID);
                }
              };

              if (Array.isArray(sheetNames)) {
                for (
                  let curIndex = 0;
                  curIndex < sheetNames.length;
                  curIndex += 1
                ) {
                  const { name, addOn, replaceName } = sheetNames[curIndex];

                  await dealSheet(name, addOn, replaceName);
                }
              } else {
                await dealSheet(sheetNames);
              }
            } else {
              mockPercent(0, 99);

              const res = await downloadFuncs[downloadFunc](
                curDownLoadParams.params,
                true,
              );

              console.log('res', res);

              if (!(res instanceof ArrayBuffer)) {
                setPercent(100);
                setStatus('error');
                clearInterval(intervalID);
              } else {
                setPercent(100);
                setStatus('success');
                downloadFile(res, newFileName || fileName);
                clearInterval(intervalID);
              }
            }
          }
        }
      } catch (e) {
        setStatus('error');
        console.log('error download', e);
      }
    } else {
      setInvalid(true);
      JSON.stringify({
        action: 'downloadPageInitFail',
        downloadId: map.get('id'),
        storageParams: downLoadParams,
        storageParams2: localStorage.getItem('downLoadParams'),
        storageParams3: localStorage.getItem(`downLoadParams-${map.get('id')}`),
      });
    }
  };

  const theme =
    status === 'loading'
      ? 'default'
      : status === 'error'
        ? 'danger'
        : 'success';

  // 缓存失效：展示统一兜底提示
  if (invalid) {
    return (
      <div className="dbo-down-page-wrap">
        <CacheExpiredTips scene="download" height={400} />
      </div>
    );
  }

  return (
    <div className="dbo-down-page-wrap">
      <div className="dbo-down-page">
        <div className="dbo-down-box">
          <img src={Downloading} className="dbo-down-box-left" />
          <div className="dbo-down-box-right">
            <div className="dbo-down-box-title">
              {formatMessage({ id: 'Download' })}
            </div>
            <div className="dbo-down-box-desc">
              <div className="dbo-down-box-describe">{desc}</div>
              <div className="dbo-down-tipbox">
                <div className="dbo-down-tipbox-lf">
                  <img src={XlsxIcon} className="dbo-down-tipbox-img" />
                  <div className="dbo-down-tipbox-filename">
                    {/* 文件名 */}
                    {curFileName}
                  </div>
                </div>
                {/* 下载状态Icon */}
                <Icon className="dbo-down-tipbox-statusicon" type={status} />
              </div>
            </div>

            <div
              id="maximum-tips"
              className={`maximum-tips ${maxErrorVisible ? 'show' : ''}`}
            >
              <p>
                {formatMessage(
                  { id: `Sorry, the export limit is set to {value} rows.` },
                  { value: transNumber(limit) },
                )}
              </p>
              <p>{formatMessage({ id: 'Please re-select the filter' })}</p>
            </div>
            {/* <Progress
          width={362}
          theme={theme}
          percent={percent}
          text={(percent) => `${Math.floor(percent)} %`}
        /> */}
          </div>
        </div>
      </div>
    </div>
  );
}
